import React, { createContext, useState, useEffect } from "react";
import api from "../api/axiosInstance";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);

  const fetchCartCount = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) return;

      const response = await api.get("/display/api/v1/cart-count", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data?.status === "success") {
        setCartCount(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch cart count:", error);
    }
  };

  useEffect(() => {
    fetchCartCount(); // Fetch on load
  }, []);

  return (
    <CartContext.Provider value={{ cartCount, fetchCartCount }}>
      {children}
    </CartContext.Provider>
  );
};
